import React from 'react';
import Icon from '../../../components/AppIcon';

const WelcomeHeader = ({ employeeName, employeeId }) => {
  const getCurrentGreeting = () => {
    const hour = new Date()?.getHours();
    if (hour < 12) return 'Good Morning';
    if (hour < 18) return 'Good Afternoon';
    return 'Good Evening';
  };

  return (
    <div className="relative overflow-hidden rounded-xl bg-tertiary border border-accent-cyan/20 p-6 md:p-8 lg:p-10">
      <div className="absolute inset-0 holographic opacity-30" />
      <div className="scan-line" />
      
      <div className="relative z-10 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-center gap-4 md:gap-6">
          <div className="flex items-center justify-center w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24 rounded-xl bg-accent-cyan/20 glow-medium">
            <Icon 
              name="Plane" 
              size={40} 
              color="var(--color-accent-cyan)"
              className="transition-smooth"
            />
          </div>
          
          <div>
            <p className="text-sm md:text-base font-caption text-muted-foreground mb-1">
              {getCurrentGreeting()}, Captain
            </p>
            <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-1">
              {employeeName}
            </h1>
            <p className="text-xs md:text-sm font-data text-accent-cyan">
              Employee ID: {employeeId}
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3 px-4 py-2 rounded-lg bg-secondary/50 border border-accent-cyan/20">
          <div className="w-2 h-2 rounded-full bg-accent-cyan animate-pulse" />
          <span className="text-xs md:text-sm font-caption text-muted-foreground">
            System Online
          </span>
        </div>
      </div>
    </div>
  );
};

export default WelcomeHeader;